import { ENABLED_FOREX_QUOTES } from 'findef'
import currencies from '@/data/currencies.json'
import { getCurrencyFlagIcon } from './flag'
import type { FormFieldOption } from '@/form/useForm'

export const getCurrencyOptions = (): FormFieldOption[] => {
  return Object.entries(currencies)
    .filter((kv) => ENABLED_FOREX_QUOTES.includes(kv[0]))
    .map(([key, _value]) => {
      return {
        label: `${key}`,
        value: key,
        key: key,
        iconLeft: getCurrencyFlagIcon(key) || undefined
      }
    })
}
